// Données fictives du mode démo (/demo) : un barbier avec ~2 mois d'activité.
// Générateur pseudo-aléatoire à graine fixe : la démo est identique à chaque ouverture.

export const COMMERCE_DEMO = {
  id: 'demo',
  nom: 'Barbier Saint-Michel',
  type: 'barbier',
  objectif_tampons: 10,
  recompense: 'Coupe offerte',
  couleur: '#2F4B8C',
  logo_url: null,
  banniere_url: null,
}

const PRENOMS = ['Yanis', 'Lucas', 'Mehdi', 'Thomas', 'Karim', 'Hugo', 'Nathan', 'Rayan', 'Louis', 'Adam',
  'Ilyes', 'Maxime', 'Sofiane', 'Enzo', 'Bilal', 'Théo', 'Amine', 'Jules', 'Samir', 'Antoine', 'Noah', 'Malik', 'Paul', 'Ismaël']

function aleatoire(graine) {
  let s = graine
  return () => { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646 }
}

export function genererDemo() {
  const r = aleatoire(42)
  const maintenant = Date.now()
  const JOUR = 86400000
  const clients = []
  const visites = []

  PRENOMS.forEach((prenom, i) => {
    const id = `demo-${i}`
    const anciennete = 10 + Math.floor(r() * 55)            // inscrit il y a 10 à 65 jours
    const inactif = i % 5 === 4                              // 1 client sur 5 n'est pas revenu
    const frequence = 5 + Math.floor(r() * 12)               // revient tous les 5 à 16 jours
    let nb = 0
    for (let j = anciennete; j > (inactif ? 35 : 0); j -= frequence) {
      const jour = new Date(maintenant - j * JOUR)
      jour.setHours(9 + Math.floor(r() * 10), Math.floor(r() * 60))
      visites.push({ id: `${id}-v${nb}`, client_id: id, commerce_id: 'demo', created_at: jour.toISOString() })
      nb++
    }
    clients.push({
      id,
      nom: prenom,
      telephone: r() > 0.4 ? `06 ${String(10 + Math.floor(r() * 89))} ${String(10 + Math.floor(r() * 89))} ${String(10 + Math.floor(r() * 89))} ${String(10 + Math.floor(r() * 89))}` : null,
      tampons: i === 0 ? 9 : nb % 10,                        // Yanis est à 1 tampon de sa récompense
      source: r() > 0.3 ? 'qr' : 'comptoir',
      consentement_offres: r() > 0.5,
      consentement_at: null,
      created_at: new Date(maintenant - anciennete * JOUR).toISOString(),
    })
  })

  // Quelques passages ce matin, pour que « Visites aujourd'hui » soit vivant
  for (const i of [3, 8, 15]) {
    const heure = new Date(maintenant - (1 + i % 3) * 3600000)
    if (heure.toDateString() === new Date(maintenant).toDateString()) {
      visites.push({ id: `demo-${i}-auj`, client_id: `demo-${i}`, commerce_id: 'demo', created_at: heure.toISOString() })
    }
  }

  clients.sort((a, b) => b.created_at.localeCompare(a.created_at))
  visites.sort((a, b) => b.created_at.localeCompare(a.created_at))
  return { clients, visites }
}
